import { render, staticRenderFns } from "./registerDialog.vue?vue&type=template&id=fd528b24&scoped=true&"
import script from "./registerDialog.vue?vue&type=script&lang=js&"
export * from "./registerDialog.vue?vue&type=script&lang=js&"
import style0 from "./registerDialog.vue?vue&type=style&index=0&id=fd528b24&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd528b24",
  null
  
)

export default component.exports